// Designul nou Prețuiește Relația: ajutoare mici, doar pe calculator. Pe telefon nu schimbă nimic.
(() => {
  const pc = window.matchMedia('(min-width: 990px)');

  // Detaliile pliabile (Idei de mesaje, Mărime, Livrare…) urcă în coloana din dreapta, sub buton, ca la Cadolia.
  // Doar secțiunea simplă (fără titlu și fără poze); cele cu instrucțiuni („Cum să îți iei amprenta?”) rămân pe loc.
  function mutaDetaliile() {
    if (!pc.matches || !document.body.classList.contains('pr-design--product')) return;
    const info = document.querySelector('.product__info-container');
    if (!info || info.querySelector('.pr-detalii-mutate')) return;
    const sectiune = [...document.querySelectorAll('#MainContent > [id*="__collapsible_content"]')].find((s) =>
      s.querySelector('.accordion') &&
      !s.querySelector('.collapsible-content__header h2:not(.visually-hidden), .collapsible-content__media'));
    if (!sectiune) return;
    const cutie = document.createElement('div');
    cutie.className = 'pr-detalii-mutate collapsible-content';
    sectiune.querySelectorAll('.accordion').forEach((a) => cutie.appendChild(a));
    info.appendChild(cutie);
    sectiune.classList.add('pr-golita');
  }

  // Săgeți ← → pentru rândurile care se derulează (produse, povești), ca să meargă și cu mouse-ul.
  function sageti() {
    document.querySelectorAll('.pr-carusel').forEach((c) => {
      if (c.dataset.prSageti) return;
      c.dataset.prSageti = '1';
      const nav = document.createElement('div');
      nav.className = 'pr-carusel__nav';
      nav.innerHTML = '<button type="button" aria-label="Înapoi">←</button><button type="button" aria-label="Înainte">→</button>';
      const [inapoi, inainte] = nav.querySelectorAll('button');
      const pas = () => c.clientWidth * 0.9;
      inapoi.addEventListener('click', () => c.scrollBy({ left: -pas(), behavior: 'smooth' }));
      inainte.addEventListener('click', () => c.scrollBy({ left: pas(), behavior: 'smooth' }));
      const stare = () => {
        inapoi.disabled = c.scrollLeft < 5;
        inainte.disabled = c.scrollLeft + c.clientWidth >= c.scrollWidth - 5;
        nav.classList.toggle('pr-carusel__nav--fara', c.scrollWidth <= c.clientWidth + 5);
      };
      c.addEventListener('scroll', stare, { passive: true });
      window.addEventListener('resize', stare);
      c.parentElement.insertBefore(nav, c);
      stare();
    });
  }

  function porneste() { mutaDetaliile(); sageti(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste);
  else porneste();
  pc.addEventListener?.('change', mutaDetaliile);
})();
